<template>
  <BaseFlexList
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <template v-slot:element="props">
      <slot
        v-bind="props"
        name="element"
      />
    </template>
    <template v-slot:filler="props">
      <slot
        v-bind="props"
        name="filler"
      />
    </template>
  </BaseFlexList>
</template>

<script>
  import BaseFlexList from '@base/v2/base-flex-list'
  import { Layout } from '@js/styles'

  export default {
    name: 'FlexCardListPrimary',
    inheritAttrs: false,
    components: {
      BaseFlexList,
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            padding: '0 12px',
          },
          element: {
            flex: 1,
            margin: `${Layout.space.md} 12px 0`,
            minWidth: '240px',
          },
          filler: {
            flex: 1,
            height: 0,
            margin: '0 12px',
            minWidth: '240px',
          },
          root: {},
        },
      };
    },
  };
</script>
